import DCPage from './dc';

export default DCPage;
